var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbaloneSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 19 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2,-8.88178e-16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0554476,0,0,0.0554476,10.6361,8.73726)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-312.657,-242.021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.327,94.18C393.484,85.368 356.756,84.444 356.756,84.444C356.756,84.444 259.088,95.141 205.034,178.539C150.98,261.937 153.297,355.373 161.019,373.906C168.741,392.439 185.356,466.818 271.753,503.327C341.559,532.825 384.648,508.114 399.475,496.995C420.007,481.595 437.699,467.355 440.041,448.601C440.103,448.109 440.173,448.755 440.173,448.755C532.24,360.742 498.647,170.249 460.311,140.241C456.569,137.312 458.161,143.808 452.378,131.344C440.71,106.193 403.734,86.607 396.803,95.45"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-312.857,-241.521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.836,448.493C443.543,439.318 442.481,424.197 439.011,412.361C426.074,368.234 382.648,379.343 372.911,383.327C345.729,394.446 336.359,415.961 350.054,438.307C363.806,460.747 392.959,449.008 395.15,437.69",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "16.25px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-312.857,-242.021)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.83518,-0.700241,0.969834,2.54173,-444.109,118.202)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 369.885,
    cy: 99.856,
    rx: 6.991,
    ry: 2.709,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.58759,-1.33355,2.11364,2.51629,-530.046,393.297)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 369.885,
    cy: 99.856,
    rx: 6.991,
    ry: 2.709,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.961906,-1.65994,2.58849,1.49998,-399.692,673.744)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 369.885,
    cy: 99.856,
    rx: 6.991,
    ry: 2.709,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.741795,-1.75444,2.67954,1.13294,-357.284,804.205)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 369.885,
    cy: 99.856,
    rx: 6.991,
    ry: 2.709,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.150119,-1.11529,2.18778,-0.294477,6.9429,795.709)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 369.885,
    cy: 99.856,
    rx: 6.991,
    ry: 2.709,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.111913,-0.831444,1.80794,-0.24335,34.3914,710.599)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 369.885,
    cy: 99.856,
    rx: 6.991,
    ry: 2.709,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.045497,-1.67031,2.54566,0.0693404,-101.26,938.428)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 369.885,
    cy: 99.856,
    rx: 6.991,
    ry: 2.709,
    style: {
      fill: "white"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbaloneSmall);
export default __webpack_public_path__ + "static/media/abaloneSmall.7c71f545d8945f5b28f065ff6319ba5c.svg";
export { ForwardRef as ReactComponent };